import { defineStore } from 'pinia'
import axios from 'axios'
import { devLog, devError } from '@/services/logger'

const url = (import.meta as any).env.VITE_API_URL

export const authStore = defineStore('auth', {
  state: () => {
    return {
      token: localStorage.getItem('token'),
      refresh: localStorage.getItem('refresh'),
      logged_at: localStorage.getItem('logged_at'),

      empSlug: localStorage.getItem('empSlug'),
      cmpU: localStorage.getItem('cmpU'),
      cpmUName: localStorage.getItem('cmpUName'),
      cmpUadmin: localStorage.getItem('cmpUadmin'),
      empEnabled: localStorage.getItem('empEnabled'),
      cmpId: localStorage.getItem('cmpId'),

      addU: localStorage.getItem('addUsers'),

      emailValidated: localStorage.getItem('emailValidated'),

      usrSlug: localStorage.getItem('usrSlug'),
      online: localStorage.getItem('online'),
    }
  },
  actions: {
    updateFunc(data) {
      this.empSlug = data.empSlug
      this.cmpU = data.cmpU
      this.cpmUName = data.cmpUName
      this.cmpUadmin = data.cmpUadmin
      this.empEnabled = data.empEnabled
      this.emailValidated = data.emailValidated
      this.cmpId = data.cmpId
      this.usrSlug = data.usrSlug
      this.addU = data.addU
      this.online = data.online

      localStorage.setItem('empSlug', data.empSlug)
      localStorage.setItem('cmpU', data.cmpU)
      localStorage.setItem('cmpUName', data.cmpUName)
      localStorage.setItem('cmpUadmin', data.cmpUadmin)
      localStorage.setItem('empEnabled', data.empEnabled)
      localStorage.setItem('emailValidated', data.emailValidated)
      localStorage.setItem('cmpId', data.cmpId)
      localStorage.setItem('usrSlug', data.usrSlug)
      localStorage.setItem('addU', data.addU)
      localStorage.setItem('online', data.online)
    },
    updateToken(token, refresh, logged_at) {
      devLog('🔄 Updating tokens in auth store')

      this.token = token
      this.refresh = refresh
      this.logged_at = logged_at

      localStorage.setItem('token', token)
      localStorage.setItem('refresh', refresh)
      localStorage.setItem('logged_at', logged_at)

      // document.cookie = 'token=' + this.token + '; path=/; SameSite=Lax; Secure;' //    HttpOnly;
      document.cookie = 'token=' + this.token + '; path=/; SameSite=Lax;'

      devLog('✅ Tokens updated successfully')
    },
    removeToken() {
      document.cookie = 'csrftoken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax;'
      document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax;'

      this.token = null
      this.refresh = null
      this.logged_at = null

      this.empSlug = null
      this.cmpU = null
      this.cpmUName = null
      this.cmpUadmin = null
      this.empEnabled = null

      this.emailValidated = null
      this.cmpId = null
      this.usrSlug = null
      this.addU = null
      this.online = null

      localStorage.removeItem('token')
      localStorage.removeItem('refresh')
      localStorage.removeItem('logged_at')

      localStorage.removeItem('empSlug')
      localStorage.removeItem('cmpU')
      localStorage.removeItem('cmpUName')
      localStorage.removeItem('cmpUadmin')
      localStorage.removeItem('empEnabled')

      localStorage.removeItem('emailValidated')
      localStorage.removeItem('cmpId')
      localStorage.removeItem('usrSlug')
      localStorage.removeItem('addU')
      localStorage.removeItem('online')
    },
    async refresh_app_layout() {
      try {
        const response = await axios.post(url + '/token/refresh/', { refresh: this.refresh })

        const { access, refresh } = response.data
        this.updateToken(access, refresh, new Date().toISOString())

        return response // Return the response for the http interceptor
      } catch (error) {
        devError(error)
        throw error // Re-throw the error so the interceptor can handle it
      }
    },
    confirmContract() {
      try {
        const axiosConfig = {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + this.token,
          },
        }

        return axios.post(url + '/empresa/confirm-contract/', {}, axiosConfig)
      } catch (error) {
        devError(error)
      }
    },
    checkMessages() {
      try {
        const axiosConfig = {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + this.token,
          },
        }

        return axios.get(url + '/sse/messages/', axiosConfig)
      } catch (error) {
        devError(error)
      }
    },
    changeUserStatus() {
      try {
        const axiosConfig = {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + this.token,
          },
        }

        const resp = axios.post(url + '/usuario/changeUserStatus/', { cmpU: this.cmpU }, axiosConfig)

        resp.then((response) => {
          localStorage.setItem('online', localStorage.getItem('online') === 'true' ? 'false' : 'true')
        })
      } catch (error) {
        devError(error)
      }
    },
  },
})
